export enum CampaignPayoutStatus {
  DONE = 'DONE',
  SKIPPED = 'SKIPPED',
  FAILED = 'FAILED',
}

export interface CampaignExpertPayoutResult {
  expertName: string;
  amount: number;
  status: CampaignPayoutStatus;
  reason?: string;
}
